import axios from 'axios';
import cookies from 'js-cookie';
import { toast } from 'sonner';
import {
  backendBaseUrl,
  accessTokenCookieName,
  refreshTokenCookieName,
} from '@/lib/constants';
import { logIn } from '@/store/index';
import { Axios } from './axios';
import { getAdminRoutes } from '@/router/AdminRoutes';

export const ResendOTP = async (parameters) => {
  try {
    const response = await axios.post(
      `${backendBaseUrl}/auth/login`,
      parameters,
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        toast.error(error.response.data.error);
      } else {
        toast.error(error.message);
      }
    } else {
      toast.error('An unexpected error occurred.');
    }
  }
};
export const login = async (parameters, navigate, dispatch) => {
  try {
    const response = await axios.post(
      `${backendBaseUrl}/auth/login`,
      parameters,
    );
    const data = response?.data;
    if (data?.enableMFA === true) {
      navigate('/verify-otp', {
        state: { email: data?.email },
      });
    } else {
      const data = response.data;
      await dispatch(logIn(data));
      cookies.set(accessTokenCookieName, data.accessToken, {
        expires: data.accessTokenExpiry,
      });
      cookies.set(refreshTokenCookieName, data.refreshToken, {
        expires: data.ExpiresIn,
      });
      localStorage.setItem('user', JSON.stringify(data));

      toast.success('Login Successful');

      setTimeout(() => {
        const routes = getAdminRoutes();
        const path = routes?.[0]?.path || '/';
        window.location.href = path;
      }, 1000);
    }

    return response.data;
  } catch (error) {
    console.log(error);

    if (axios.isAxiosError(error)) {
      if (error.response) {
        if (error.response.data.error === 'EMAIL_NOT_VERIFIED') {
          toast.info('Please verify your email.');
          const data = await ResendOTP({ email: parameters.email });
          if (data.success) {
            navigate('/verify-otp', { state: { email: parameters.email } });
          }
        } else {
          toast.error(error.response.data.message);
        }
      } else {
        toast.error(error.message);
      }
    }
  }
};

export const verifyOTP = async (parameters, dispatch) => {
  const response = await axios.post(
    `${backendBaseUrl}/auth/verify-otp`,
    parameters,
  );
  await dispatch(logIn(response.data));
  const data = response.data;
  cookies.set(accessTokenCookieName, data.accessToken, {
    expires: data.accessTokenExpiry,
  });
  cookies.set(refreshTokenCookieName, data.refreshToken, {
    expires: data.ExpiresIn,
  });
  localStorage.setItem('user', JSON.stringify(data));
  return response.data;
};

export const loginWithEmail = async (parameters, navigate) => {
  try {
    const response = await axios.post(
      `${backendBaseUrl}/auth/login`,
      parameters,
    );
    if (response.data && navigate) {
      toast.success('OTP sent successfully to your email.');
      navigate('/verify-otp', {
        state: { email: parameters.email },
      });
    }
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    } else {
      toast.error('An unexpected error occurred.');
    }
  }
};

export const forgotPassword = async (parameters) => {
  try {
    const response = await axios.post(
      `${backendBaseUrl}/auth/forget-password`,
      parameters,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    } else {
      toast.error('An unexpected error occurred.');
    }
  }
};
export const resetPassword = async (parameters) => {
  const response = await Axios.post(
    `${backendBaseUrl}/auth/reset-password`,
    parameters,
  );
  return response;
};
export const setPassword = async (parameters) => {
  const response = await Axios.post(
    `${backendBaseUrl}/auth/set-password`,
    parameters,
  );
  return response;
};
export const changePassword = async (parameters) => {
  const response = await Axios.post(
    `${backendBaseUrl}/auth/change-password`,
    parameters,
  );
  return response;
};
export const handleLogout = () => {
  cookies.remove(accessTokenCookieName);
  cookies.remove(refreshTokenCookieName);
  window.location.href = '/';
};
export const refreshAccessToken = async () => {
  const refreshToken = cookies.get(refreshTokenCookieName);

  if (!refreshToken) {
    console.log('No refresh token found');
    handleLogout();
    throw new Error('No refresh token available');
  }

  try {
    console.log('Attempting to refresh access token...');
    const response = await Axios.post(`${backendBaseUrl}/auth/refresh-token`, {
      refreshToken,
    });
    console.log('Refresh token response:', response);

    const data = response;

    if (!data.accessToken) {
      throw new Error('No access token received in refresh response');
    }

    // Set access token
    cookies.set(accessTokenCookieName, data.accessToken, {
      expires: data.accessTokenExpiry,
    });
    console.log('Access token updated successfully');

    // Set refresh token if provided in response
    if (data.refreshToken) {
      cookies.set(refreshTokenCookieName, data.refreshToken, {
        expires: data.ExpiresIn,
      });
      console.log('Refresh token updated successfully');
    }

    return data.accessToken;
  } catch (error) {
    console.error('Refresh token failed:', error);
    console.error('Error response:', error.response?.data);

    handleLogout();
    throw error;
  }
};

export const getLoginConfigs = async () => {
  const host = window.location.host.replace(/^www\./, '');
  const response = await axios.get(
    `${backendBaseUrl}/get-login-configs?loginDomain=${host}`,
  );
  return response;
};

// Utility function to manually refresh access token
export const manualRefreshToken = async () => {
  try {
    const newToken = await refreshAccessToken();
    console.log('Manual token refresh successful');
    return newToken;
  } catch (error) {
    console.error('Manual token refresh failed:', error);
    throw error;
  }
};
